export const trackPageView = (path) => {
  if (window.gtag) {
    window.gtag("config", "G-RKH712T59H", {
      page_path: path,
    });
  }
};
